import { useWatch } from 'react-hook-form';
import { PricingPackagesFormValues } from '../../../../../../store/features/packages/types';
import { PricingProductType } from '../../../../../../store/features/products/types';
import { useSelectPackageContext } from '../../../PackageSelectionForm/selectPackageContext';

import { MuiStack } from '../../../../../../../../modules/material';
import CardWrapper from '../../shared/CardWrapper';
import ProductOptions from '../../ProductOptions';
import SecondaryProductCard from '../SecondaryProductCard';
import CheckboxField from '../../../../../../shared/formElements/CheckboxField';

export interface MultipleProductsListProps
  extends Pick<PricingProductType, 'products'> {}

export default function MultipleProductsList(props: MultipleProductsListProps) {
  const { products } = props;
  const fieldName = 'productsSelections.productMultipleIds';

  const { handleChangeSelections } = useSelectPackageContext();

  const productMultipleIds = useWatch<PricingPackagesFormValues>({
    name: fieldName,
  }) as PricingPackagesFormValues['productsSelections']['productMultipleIds'];

  return (
    <MuiStack
      spacing={2}
      data-testid="secondary-multiple-products-list"
      className="informa-payment-multiple-products"
    >
      {products.map((product) => {
        const isProductOptions =
          product.productOptionsList.length > 0 &&
          productMultipleIds?.includes(product.id);

        return (
          <CardWrapper
            shiftedContent={
              isProductOptions && (
                <MuiStack spacing={2.5}>
                  <ProductOptions options={product.productOptionsList} />
                </MuiStack>
              )
            }
            paddingVariant="smallTopBottom"
            key={product.id}
            className="informa-payment-multiple-products__item"
          >
            <CheckboxField<PricingPackagesFormValues>
              name={fieldName}
              value={product.id}
              label={<SecondaryProductCard product={product} />}
              onChange={() => handleChangeSelections()}
              labelOffset="small"
              multiple
              sx={{ m: 0 }}
              data-testid="secondary-checkbox-input"
            />
          </CardWrapper>
        );
      })}
    </MuiStack>
  );
}
